// Warstwa Canvas 2D: rozmiar z devicePixelRatio, czyszczenie ekranu.

export class Stage {
  readonly canvas: HTMLCanvasElement;
  private readonly ctx: CanvasRenderingContext2D;
  width = 0;
  height = 0;
  private dpr = 1;

  constructor(canvas: HTMLCanvasElement) {
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Brak kontekstu 2D');
    this.canvas = canvas;
    this.ctx = context;
  }

  get context(): CanvasRenderingContext2D {
    return this.ctx;
  }

  /** Dopasowuje bufor canvasu do rozmiaru CSS i devicePixelRatio. */
  syncSize(): { width: number; height: number } {
    const dpr = Math.min(2, globalThis.devicePixelRatio || 1);
    const width = Math.max(1, Math.round(this.canvas.clientWidth));
    const height = Math.max(1, Math.round(this.canvas.clientHeight));
    if (this.width !== width || this.height !== height || this.dpr !== dpr) {
      this.width = width;
      this.height = height;
      this.dpr = dpr;
      this.canvas.width = Math.round(width * dpr);
      this.canvas.height = Math.round(height * dpr);
    }
    return { width, height };
  }

  /** Czysci ekran i ustawia transformacje na piksele CSS. */
  begin(fill: string): CanvasRenderingContext2D {
    const { ctx } = this;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.fillStyle = fill;
    ctx.fillRect(0, 0, this.width, this.height);
    return ctx;
  }
}
